<nav class="navbar navbar-expand-lg bg-primary sticky-top">
  <div class="container-fluid mt-1">

    <!-- ===================================== -->
    <!-- TÍTULO + BOTÃO BACK -->
    <h1 class="d-flex align-items-center">

      <ng-container *ngIf="customBackButton; else defaultBack">
        <ng-container *ngTemplateOutlet="customBackButton"></ng-container>
      </ng-container>

      <ng-template #defaultBack>
        <a *ngIf="btnBack"
           class="btn-back mx-2"
           defaultHref="#"
           (click)="back()">
          <i class="pi pi-angle-left"></i>
        </a>
      </ng-template>

      {{ title }}

    </h1>

    <!-- ===================================== -->
    <!-- BOTÃO HAMBURGER (MOBILE) -->
    <button
      *ngIf="btnConfig"
      class="btn btn-light d-lg-none"
      type="button"
      (click)="menuOpen = !menuOpen">
      <i class="fa fa-bars"></i>
    </button>

    <!-- ===================================== -->
    <!-- MENU COLAPSÁVEL -->
    <div *ngIf="btnConfig"
         class="collapse navbar-collapse"
         [class.show]="menuOpen">

      <div class="menu-items d-flex flex-column flex-lg-row ms-auto">

        <!-- infor-header + pdf + botões externos -->
        <ng-content></ng-content>

        <!-- ===================================== -->
        <!-- BOTÕES FIXOS DO NAVBAR -->

        <a *ngIf="btnHome"
          class="btn btn-menu"
          routerLink="/home">
          <i class="pi pi-home"></i>
          <span class="btn-menu-text">Início</span>
        </a>

        <a *ngIf="acompanhamento"
          class="btn btn-menu"
          routerLink="/acompanhamento-especial">
          <i class="fa-solid fa-eye"></i>
          <span class="btn-menu-text">Acompanhamento</span>
        </a>

        <a class="btn btn-menu"
          routerLink="/gerir-carteira-pesquisa">
          <i class="pi pi-wallet"></i>
          <span class="btn-menu-text">Carteira</span>
        </a>

        <a class="btn btn-menu"
          routerLink="/historico-pesquisa">
          <i class="pi pi-history"></i>
          <span class="btn-menu-text">Histórico</span>
        </a>

        <a (click)="op.toggle($event)"
          class="btn btn-menu text-info">
          <i class="fa-solid fa-universal-access"></i>
          <span class="btn-menu-text">Acessibilidade</span>
        </a>

      </div>
    </div>

  </div>
</nav>

<!-- OVERLAY ACESSIBILIDADE -->
<p-overlayPanel
  #op
  styleClass="gord-overlaypanel"
  [showCloseIcon]="false"
  [dismissable]="true"
  [autoZIndex]="true"
  [baseZIndex]="99999"
  appendTo="body"
>
  <app-accessibility></app-accessibility>
</p-overlayPanel>